<template>
	<div class="modern-login">
		<!-- Animated Background -->
		<div class="background-animation">
			<div class="floating-shapes">
				<div class="shape shape-1"></div>
				<div class="shape shape-2"></div>
				<div class="shape shape-3"></div>
				<div class="shape shape-4"></div>
				<div class="shape shape-5"></div>
			</div>
		</div>

		<!-- Header -->
		<header class="login-header">
			<div class="header-content">
				<div class="logo-section">
					<a href="https://makipos.la/" target="_blank" class="logo-link">
						<img :src="logoLogin1" alt="Makipos" class="logo">
					</a>
				</div>
				<nav class="nav-links">
					<a href="https://makipos.la/soluciones" target="_blank" class="nav-link">Soluciones</a>
					<a href="https://makipos.la/caracteristicas" target="_blank" class="nav-link">Características</a>
					<a href="https://makipos.la/plan-mega" target="_blank" class="nav-link">Planes</a>
				</nav>
			</div>
		</header>

		<!-- Main Content -->
		<main class="main-content">
			<div class="content-container">
				<!-- Login Form Section -->
				<div class="form-section">
					<div class="glass-card" v-if="showLogin">
						<div class="card-header">
							<div class="centered-logo">
								<img :src="logoLogin" alt="Makipos" class="main-logo">
							</div>
							<h1 class="welcome-title">Bienvenido</h1>
							<p class="welcome-subtitle">Inicia sesión para tener el control total de tu negocio</p>
						</div>

						<form @submit.prevent="signin" class="login-form">
							<div class="input-group">
								<div class="input-wrapper">
									<input 
										type="email"
										v-model="user"
										placeholder="Correo electrónico"
										class="modern-input"
										required
									>
									<div class="input-icon">
										<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
											<circle cx="12" cy="7" r="4"></circle>
										</svg>
									</div>
								</div>
							</div>

							<div class="input-group">
								<div class="input-wrapper">
									<input 
										:type="showPassword ? 'text' : 'password'"
										v-model="password"
										placeholder="Contraseña"
										class="modern-input"
										required
									>
									<div class="input-icon">
										<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
											<circle cx="12" cy="16" r="1"></circle>
											<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
										</svg>
									</div>
									<button 
										type="button" 
										class="password-toggle"
										@click="togglePasswordVisibility('login')"
									>
										<svg v-if="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
											<circle cx="12" cy="12" r="3"></circle>
										</svg>
										<svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
											<line x1="1" y1="1" x2="23" y2="23"></line>
										</svg>
									</button>
								</div>
							</div>

							<button 
								type="submit" 
								class="login-button"
								:class="{ 'loading': isLoading }"
								:disabled="isLoading"
							>
								<span v-if="!isLoading">Iniciar Sesión</span>
								<div v-else class="loading-spinner"></div>
							</button>

							<div class="form-footer">
								<button type="button" class="forgot-password" @click="showForgetPasswords">
									¿Olvidaste tu contraseña?
								</button>
								<p class="terms-text">
									Al usar este servicio aceptas nuestros 
									<a href="https://makipos.la/terminos-y-condiciones" target="_blank" class="terms-link">
										Términos y Condiciones
									</a>
								</p>
							</div>
						</form>
					</div>

					<!-- Register Form -->
					<div class="glass-card register-card" v-if="showRegister">
						<div class="card-header">
							<h1 class="welcome-title">Crear Cuenta</h1>
							<p class="welcome-subtitle">Únete a miles de empresas que confían en Makipos</p>
						</div>

						<form class="register-form">
							<div class="form-grid">
								<div class="form-section-title">
									<h3>Datos de la Compañía</h3>
								</div>
								<div class="input-group">
									<input 
										type="text"
										v-model="model.tradeName"
										placeholder="Nombre Comercial"
										class="modern-input"
										required
									>
								</div>
								<div class="input-group">
									<input 
										type="text"
										v-model="model.businessName"
										placeholder="Razón Social"
										class="modern-input"
										required
									>
								</div>
								<div class="input-group">
									<input 
										type="number"
										v-model="model.ruc"
										placeholder="RUC"
										class="modern-input"
										required
									>
								</div>

								<div class="form-section-title">
									<h3>Datos del Usuario</h3>
								</div>
								<div class="input-group">
									<input 
										type="email"
										v-model="model.email"
										placeholder="Correo Electrónico"
										class="modern-input"
										required
									>
								</div>
								<div class="input-group">
									<input 
										:type="showPasswordRegister ? 'text' : 'password'"
										v-model="model.password"
										placeholder="Contraseña"
										class="modern-input"
										required
									>
									<button 
										type="button" 
										class="password-toggle"
										@click="togglePasswordVisibility('register')"
									>
										<svg v-if="!showPasswordRegister" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
											<circle cx="12" cy="12" r="3"></circle>
										</svg>
										<svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
											<line x1="1" y1="1" x2="23" y2="23"></line>
										</svg>
									</button>
								</div>
								<div class="input-group">
									<input 
										:type="showPasswordConfirm ? 'text' : 'password'"
										v-model="confirmPassword"
										placeholder="Confirmar Contraseña"
										class="modern-input"
										required
									>
									<button 
										type="button" 
										class="password-toggle"
										@click="togglePasswordVisibility('confirm')"
									>
										<svg v-if="!showPasswordConfirm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
											<circle cx="12" cy="12" r="3"></circle>
										</svg>
										<svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
											<line x1="1" y1="1" x2="23" y2="23"></line>
										</svg>
									</button>
								</div>
							</div>

							<div class="form-actions">
								<button type="button" class="secondary-button" @click="showLogins">
									Cancelar
								</button>
								<button type="button" class="login-button" @click="register">
									Crear Cuenta
								</button>
							</div>
						</form>
					</div>

					<!-- Forgot Password Form -->
					<div class="glass-card" v-if="showForgetPassword">
						<div class="card-header">
							<h1 class="welcome-title">Recuperar Contraseña</h1>
							<p class="welcome-subtitle">Ingresa tu correo para recibir instrucciones</p>
						</div>

						<form class="login-form">
							<div class="input-group">
								<div class="input-wrapper">
									<input 
										type="email"
										v-model="userRecovery"
										placeholder="Correo electrónico"
										class="modern-input"
										required
									>
									<div class="input-icon">
										<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
											<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
											<polyline points="22,6 12,13 2,6"></polyline>
										</svg>
									</div>
								</div>
							</div>

							<div class="form-actions">
								<button type="button" class="secondary-button" @click="showLogins">
									Cancelar
								</button>
								<button type="button" class="login-button" @click="sendRecovery">
									Enviar
								</button>
							</div>
						</form>
					</div>
				</div>

				<!-- Features Section -->
				<div class="features-section">
					<div class="features-container">
						<div class="feature-showcase">
							<div class="feature-image">
								<img :src="imageSelected.image" alt="Feature" class="showcase-image">
								<div class="image-overlay"></div>
							</div>
							<div class="feature-content">
								<h2 class="feature-title">{{ imageSelected.name }}</h2>
								<div class="feature-indicators">
									<button 
										v-for="(item, index) in imagesItems" 
										:key="item.id"
										class="indicator"
										:class="{ 'active': item.status }"
										@click="changeImage(index)"
									>
										<span class="indicator-text">{{ item.name }}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>

		<!-- WhatsApp Widget -->
		<vue-whatsapp-widget
			phoneNumber="+593979940429"
			textReply="En Línea"
			companyName="Makipos"
			:messages='["Hola, ¿Necesitas ayuda? Comunícate con nosotros."]'
			companyLogo="https://maki-static.s3.amazonaws.com/ADSP0003_image/ADSP0003_0501662316001/maki1.png"
		/>
	</div>
</template>

<script>
import VueWhatsappWidget from 'vue-whatsapp-widget';
import helper from '@/shared/helper';
import { required, email, maxLength, minLength, numeric } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

function created() {
	this.backgroundImage = process.env.COMPANY_LOGIN_BACKGROUND_ECU;
	this.companyLoginLogo = process.env.COMPANY_LOGIN_LOGO_ECU;
	this.model.codeWarehouse = '001';
	this.model.codeEmissionPoint = '001';
	let cont = 0;
	setInterval(() => {
		this.changeImage(cont);
		cont += 1;
		if (cont > 4) {
			cont = 0;
		}
	}, 4000);
}

function deleteModel() {
	this.model = {
		tradeName: null,
		businessName: null,
		ruc: null,
		email: null,
		password: null,
		codeWarehouse: '001',
		codeEmissionPoint: '001',
	};
	this.confirmPassword = null;
	this.userRecovery = null;
}

function openModalRecovery() {
	this.recovery = !this.recovery;
	this.userRecovery = null;
}

async function register() {
	const emailUser = `${(this.model.email).split('@')[0]}`;
	const changeEmailUser = `${emailUser}@quipu.com`;
	const emailCode = `${(this.model.email).substring(0, 2)}`;
	const codeComp = `${(this.model.ruc).substring(0, 4)}`;
	const codeTrade = `${(this.model.tradeName).substring(0, 2)}`;
	const companyCode = `${emailCode}${codeComp}${codeTrade}`;
	const dataRegister = {
		email: this.model.email,
		codeUser: changeEmailUser,
		countryId: 63,
		languages: {
			en: { id: 'En', name: 'English', isSelected: true },
			es: { id: 'Es', name: 'Español', isSelected: true },
		},
		codeCompany: companyCode,
		codeProject: 'maki_project',
		codeTemplate: '9kda7a',
		companyParentId: 0,
		nombreComercial: this.model.businessName,
		razonSocial: this.model.tradeName,
		ruc: this.model.ruc,
		password: this.model.password,
		flagAppCompany: true,
		plans: 1,
		codeWarehouse: this.model.codeWarehouse !== '' && this.model.codeWarehouse !== null ?
			this.model.codeWarehouse : '001',
		codeEmissionPoint: this.model.codeEmissionPoint !== '' && this.model.codeEmissionPoint !== null ?
			this.model.codeEmissionPoint : '001',
	};
	try {
		const headers = {
			Accept: 'application/vnd.apiacl.v2+json',
		};
		await this.$httpSales.post('companies/public', dataRegister, { headers });
		this.showNotification('Cuenta creada correctamente');
		this.showLogins();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'COMPANY_RUC_EXISTS') {
				this.showNotification('El ruc ya fue registrado en otra compania.Recuerda el ruc debe ser único',
					'error');
			} else if (error.data.codeCompany) {
				this.showGenericError('El codigo de compania ya existe.');
			}
		}
	} finally {
		this.deleteModel();
	}
}

async function sendRecovery() {
	const payload = {
		email: this.userRecovery,
	};
	try {
		const { data: response } = await this.$httpSales.post('employees/by-email', payload);
		if (response.emailNotification === null || response.emailNotification === '') {
			this.showGenericError('No está configurado su correo de notificación, pongase en contacto con soporte.');
		} else {
			const sendReset = {
				email: response.email,
				emailNotification: response.emailNotification,
			};
			await this.$httpSales.post('employees/reset-password', sendReset);
			this.showNotification(`Su contraseña ha sido reestablecida, Por favor, verifique su correo de notificación ${response.emailNotification}`);
		}
	} catch (error) {
		this.showGenericError();
	} finally {
		this.showLogins();
	}
}

async function signin() {
	window.localStorage.clear();
	this.isLoading = true;
	const userData = {
		email: this.user,
		password: this.password,
		codeApp: process.env.APP_CODE,
	};
	try {
		const response = await this.$httpAcl.post('authenticate', userData);
		const user = response.data;
		const inLocalStorage = JSON.stringify(user);
		const { token, codeProject } = user;
		localStorage.setItem(process.env.STORAGE_USER_KEY, inLocalStorage);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::codeProject`, codeProject);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, token);
		this.setToken(token);
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const { data: current } = await this.$http.get('company-token', { headers });
		const currentInLocalStorage = JSON.stringify(current);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::adminUser`, currentInLocalStorage);
		this.$bus.$emit('USER_INFO', currentInLocalStorage);
		this.setUser(current);
		this.$router.push({ name: 'main' });
	} catch (e) {
		this.showSnackBar({
			text: 'Sus credenciales no son válidas',
			color: 'error',
		});
	} finally {
		this.isLoading = false;
	}
}

function validations() {
	return {
		model: {
			tradeName: { required },
			businessName: { required },
			ruc: { required },
			email: { required, email },
			password: { required },
			codeWarehouse: {
				required,
				numeric,
				maxLength: maxLength(3),
				minLength: minLength(3),
			},
			codeEmissionPoint: {
				required,
				numeric,
				maxLength: maxLength(3),
				minLength: minLength(3),
			},
		},
	};
}

function validDigitsRuc() {
	if (this.model.ruc.length === 13) {
		return true;
	}
	return false;
}

function fConfirmPassword() {
	return this.model.password === this.confirmPassword;
}

async function loadPlasticTaxes() {
	try {
		const { data: response } = await this.$httpSales.get(`/electronic-taxes/${this.countryId}/default`);
		helper.setLocalData('tax-icb', response);
	} catch (error) {
		this.showGenericError();
	}
}

function changeImage(indexImage) {
	this.imagesItems = this.imagesItems.map((img, index) => {
		const image = { ...img };
		if (index === indexImage) {
			image.status = true;
			this.imageSelected = image;
		} else {
			image.status = false;
		}
		return image;
	});
}

function showRegisters() {
	this.showLogin = false;
	this.showForgetPassword = false;
	this.showRegister = true;
	this.deleteModel();
}

function showLogins() {
	this.showLogin = true;
	this.showForgetPassword = false;
	this.showRegister = false;
	this.deleteModel();
}

function showForgetPasswords() {
	this.showLogin = false;
	this.showForgetPassword = true;
	this.showRegister = false;
	this.deleteModel();
}

function togglePasswordVisibility(field) {
	if (field === 'login') {
		this.showPassword = !this.showPassword;
	} else if (field === 'register') {
		this.showPasswordRegister = !this.showPasswordRegister;
	} else if (field === 'confirm') {
		this.showPasswordConfirm = !this.showPasswordConfirm;
	}
}

function data() {
	return {
		backgroundImage: '',
		logoLogin: 'https://maki-acl1.s3.amazonaws.com/icons/logo_maki_contable.png',
		logoLogin1: 'https://maki-bucket1.s3.amazonaws.com/7102C744-A748-4EA2-8B4A-7664ED46F9B5.svg',
		countryId: null,
		user: '',
		password: '',
		isLoading: false,
		createAccount: false,
		imagesItems: [
			{
				id: 1,
				name: 'Facturación Electrónica',
				image: '/static/img/login/banner1.png',
				status: true,
			},
			{
				id: 2,
				name: 'Punto de venta',
				image: '/static/img/login/banner2.png',
				status: false,
			},
			{
				id: 3,
				name: 'Venta Online',
				image: '/static/img/login/banner3.png',
				status: false,
			},
			{
				id: 4,
				name: 'Control de Stock',
				image: '/static/img/login/banner4.png',
				status: false,
			},
			{
				id: 5,
				name: 'Control Financiero',
				image: '/static/img/login/banner5.png',
				status: false,
			},
		],
		imageSelected: { id: 1, image: '/static/img/login/banner1.png', status: true },
		showLogin: true,
		showRegister: false,
		showForgetPassword: false,
		model: {
			tradeName: null,
			businessName: null,
			ruc: null,
			email: null,
			password: null,
			codeWarehouse: null,
			codeEmissionPoint: null,
		},
		confirmPassword: null,
		userRecovery: null,
		showPassword: false,
		showPasswordRegister: false,
		showPasswordConfirm: false,
	};
}

export default {
	name: 'modern-login',
	created,
	components: {
		VueWhatsappWidget,
	},
	data,
	computed: {
		validDigitsRuc,
		fConfirmPassword,
	},
	methods: {
		loadPlasticTaxes,
		signin,
		deleteModel,
		register,
		openModalRecovery,
		sendRecovery,
		changeImage,
		showRegisters,
		showLogins,
		showForgetPasswords,
		togglePasswordVisibility,
		...mapActions('user', [
			'setUser',
			'setToken',
		]),
		...mapActions([
			'showSnackBar',
		]),
	},
	validations,
};
</script>

<style lang="scss" scoped>
* {
	box-sizing: border-box;
}

.modern-login {
	min-height: 100vh;
	font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	background: linear-gradient(135deg, #02979b 0%, #0a6b6e 50%, #134e50 100%);
	position: relative;
	overflow-x: hidden;
}

// Animated Background
.background-animation {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 0;
	pointer-events: none;
}

.floating-shapes {
	position: relative;
	width: 100%;
	height: 100%;
}

.shape {
	position: absolute;
	border-radius: 50%;
	background: linear-gradient(45deg, rgba(255, 92, 0, 0.1), rgba(255, 92, 0, 0.05));
	animation: float 20s infinite linear;

	&.shape-1 {
		width: 80px;
		height: 80px;
		top: 20%;
		left: 10%;
		animation-delay: 0s;
	}

	&.shape-2 {
		width: 120px;
		height: 120px;
		top: 60%;
		left: 80%;
		animation-delay: -5s;
	}

	&.shape-3 {
		width: 60px;
		height: 60px;
		top: 80%;
		left: 20%;
		animation-delay: -10s;
	}

	&.shape-4 {
		width: 100px;
		height: 100px;
		top: 10%;
		left: 70%;
		animation-delay: -15s;
	}

	&.shape-5 {
		width: 140px;
		height: 140px;
		top: 40%;
		left: 5%;
		animation-delay: -8s;
	}
}

@keyframes float {
	0% {
		transform: translateY(0px) rotate(0deg);
		opacity: 0.7;
	}
	50% {
		transform: translateY(-20px) rotate(180deg);
		opacity: 0.3;
	}
	100% {
		transform: translateY(0px) rotate(360deg);
		opacity: 0.7;
	}
}

// Header
.login-header {
	position: relative;
	z-index: 10;
	padding: 0.5rem 2rem;
	backdrop-filter: blur(10px);
	background: rgba(255, 255, 255, 0.1);
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	@media (max-width: 768px) {
		padding: 0.5rem 1rem;
	}
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 768px) {
		flex-direction: column;
		gap: 1rem;
	}
}

.logo-section {
	.logo-link {
		display: block;
		transition: transform 0.3s ease;

		&:hover {
			transform: scale(1.05);
		}
	}

	.logo {
		height: 30px;
		width: auto;

		@media (max-width: 768px) {
			height: 40px;
		}
	}
}

.nav-links {
	display: flex;
	gap: 2rem;

	@media (max-width: 768px) {
		gap: 1rem;
		flex-wrap: wrap;
		justify-content: center;
	}
}

.nav-link {
	color: white;
	text-decoration: none;
	font-weight: 500;
	font-size: 0.95rem;
	transition: all 0.3s ease;
	position: relative;

	&:hover {
		color: #ff5c00;
		transform: translateY(-2px);
	}

	&::after {
		content: '';
		position: absolute;
		bottom: -5px;
		left: 0;
		width: 0;
		height: 2px;
		background: #ff5c00;
		transition: width 0.3s ease;
	}

	&:hover::after {
		width: 100%;
	}

	@media (max-width: 768px) {
		font-size: 0.9rem;
	}
}

// Main Content
.main-content {
	position: relative;
	z-index: 5;
	min-height: calc(100vh - 82px);
	display: flex;
	align-items: center;
	padding: 2rem;

	@media (max-width: 768px) {
		padding: 1rem;
		min-height: calc(100vh - 120px);
	}
}

.content-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4rem;
	max-width: 1400px;
	margin: 0 auto;
	width: 100%;

	@media (max-width: 1024px) {
		grid-template-columns: 1fr;
		gap: 2rem;
	}
}

// Glass Card
.glass-card {
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(20px);
	border-radius: 24px;
	width: 90%;
	padding: 3rem;
	box-shadow: 
		0 25px 50px rgba(0, 0, 0, 0.1),
		0 0 0 1px rgba(255, 255, 255, 0.2);
	border: 1px solid rgba(255, 255, 255, 0.2);
	transition: all 0.3s ease;
	animation: slideInUp 0.6s ease-out;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 
			0 35px 70px rgba(0, 0, 0, 0.15),
			0 0 0 1px rgba(255, 255, 255, 0.3);
	}

	@media (max-width: 768px) {
		padding: 2rem;
		border-radius: 20px;
	}

	&.register-card {
		max-height: 80vh;
		overflow-y: auto;
	}
}

@keyframes slideInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.card-header {
	text-align: center;
	margin-bottom: 2.5rem;
}

.centered-logo {
	display: flex;
	justify-content: center;
	margin-bottom: 1.5rem;
}

.main-logo {
	height: 80px;
	width: auto;
	transition: transform 0.3s ease;

	&:hover {
		transform: scale(1.05);
	}

	@media (max-width: 768px) {
		height: 60px;
	}
}

.welcome-title {
	font-size: 2.5rem;
	font-weight: 700;
	color: #1a1a1a;
	margin-bottom: 0.5rem;
	background: linear-gradient(135deg, #02979b, #ff5c00);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;

	@media (max-width: 768px) {
		font-size: 2rem;
	}
}

.welcome-subtitle {
	font-size: 1.1rem;
	color: #666;
	font-weight: 400;
	line-height: 1.5;

	@media (max-width: 768px) {
		font-size: 1rem;
	}
}

// Form Styles
.login-form, .register-form {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}

.input-group {
	position: relative;
}

.input-wrapper {
	position: relative;
	display: flex;
	align-items: center;
}

.modern-input {
	width: 100%;
	padding: 1rem 1.25rem 1rem 3.5rem;
	border: 2px solid #e1e5e9;
	border-radius: 16px;
	font-size: 1rem;
	font-weight: 500;
	color: #1a1a1a;
	background: rgba(255, 255, 255, 0.8);
	transition: all 0.3s ease;
	backdrop-filter: blur(10px);

	&::placeholder {
		color: #9ca3af;
		font-weight: 400;
	}

	&:focus {
		outline: none;
		border-color: #02979b;
		background: rgba(255, 255, 255, 0.95);
		box-shadow: 0 0 0 4px rgba(2, 151, 155, 0.1);
		transform: translateY(-2px);
	}

	&:hover {
		border-color: #02979b;
		background: rgba(255, 255, 255, 0.9);
	}

	@media (max-width: 768px) {
		padding: 0.875rem 1rem 0.875rem 3rem;
		font-size: 0.95rem;
	}
}

.input-icon {
	position: absolute;
	left: 1.25rem;
	width: 20px;
	height: 20px;
	color: #9ca3af;
	transition: color 0.3s ease;
	pointer-events: none;

	svg {
		width: 100%;
		height: 100%;
	}

	@media (max-width: 768px) {
		left: 1rem;
		width: 18px;
		height: 18px;
	}
}

.modern-input:focus + .input-icon {
	color: #02979b;
}

.password-toggle {
	position: absolute;
	right: 1.25rem;
	background: none;
	border: none;
	cursor: pointer;
	color: #9ca3af;
	width: 20px;
	height: 20px;
	transition: color 0.3s ease;

	&:hover {
		color: #02979b;
	}

	svg {
		width: 100%;
		height: 100%;
	}

	@media (max-width: 768px) {
		right: 1rem;
		width: 18px;
		height: 18px;
	}
}

// Buttons
.login-button {
	background: linear-gradient(135deg, #ff5c00 0%, #e55100 100%);
	color: white;
	border: none;
	border-radius: 16px;
	padding: 1rem 2rem;
	font-size: 1.1rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
	min-height: 56px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover:not(:disabled) {
		transform: translateY(-2px);
		box-shadow: 0 15px 35px rgba(255, 92, 0, 0.4);
	}

	&:active {
		transform: translateY(0);
	}

	&:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}

	&.loading {
		pointer-events: none;
	}

	@media (max-width: 768px) {
		padding: 0.875rem 1.5rem;
		font-size: 1rem;
		min-height: 50px;
	}
}

.secondary-button {
	background: transparent;
	color: #02979b;
	border: 2px solid #02979b;
	border-radius: 16px;
	padding: 1rem 2rem;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;

	&:hover {
		background: #02979b;
		color: white;
		transform: translateY(-2px);
		box-shadow: 0 10px 25px rgba(2, 151, 155, 0.3);
	}

	@media (max-width: 768px) {
		padding: 0.875rem 1.5rem;
		font-size: 0.95rem;
	}
}

.loading-spinner {
	width: 24px;
	height: 24px;
	border: 3px solid rgba(255, 255, 255, 0.3);
	border-top: 3px solid white;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

// Form Footer
.form-footer {
	text-align: center;
	margin-top: 1rem;
}

.forgot-password {
	background: none;
	border: none;
	color: #02979b;
	font-size: 0.95rem;
	font-weight: 500;
	cursor: pointer;
	text-decoration: underline;
	margin-bottom: 1.5rem;
	transition: color 0.3s ease;

	&:hover {
		color: #ff5c00;
	}
}

.terms-text {
	font-size: 0.85rem;
	color: #666;
	line-height: 1.4;
	margin: 0;

	@media (max-width: 768px) {
		font-size: 0.8rem;
	}
}

.terms-link {
	color: #02979b;
	text-decoration: none;
	font-weight: 500;
	transition: color 0.3s ease;

	&:hover {
		color: #ff5c00;
		text-decoration: underline;
	}
}

// Register Form
.form-grid {
	display: grid;
	gap: 1.5rem;
}

.form-section-title {
	margin: 1.5rem 0 0.5rem 0;

	h3 {
		color: #02979b;
		font-size: 1.2rem;
		font-weight: 600;
		margin: 0;
		padding-bottom: 0.5rem;
		border-bottom: 2px solid #e1e5e9;
	}
}

.form-actions {
	display: flex;
	gap: 1rem;
	margin-top: 1.5rem;

	@media (max-width: 768px) {
		flex-direction: column;
	}
}

// Features Section
.features-section {
	display: flex;
	align-items: stretch;
	justify-content: center;

	@media (max-width: 1024px) {
		display: none !important;
	}
}

.features-container {
	width: 100%;
	max-width: 600px;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.feature-showcase {
	background: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(20px);
	border-radius: 24px;
	padding: 2rem;
	border: 1px solid rgba(255, 255, 255, 0.2);
	animation: slideInRight 0.6s ease-out;
	height: 100%;

	@media (max-width: 768px) {
		padding: 1.5rem;
		border-radius: 20px;
	}
}

@keyframes slideInRight {
	from {
		opacity: 0;
		transform: translateX(30px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

.feature-image {
	position: relative;
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: 2rem;
	aspect-ratio: 16/9;
	max-height: 300px;
}

.showcase-image {
	width: 100%;
	height: 100%;
	object-fit: contain;
	transition: transform 0.3s ease;
}

.image-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(45deg, rgba(2, 151, 155, 0.1), rgba(255, 92, 0, 0.1));
	transition: opacity 0.3s ease;
}

.feature-showcase:hover .showcase-image {
	transform: scale(1.05);
}

.feature-showcase:hover .image-overlay {
	opacity: 0.7;
}

.feature-content {
	text-align: center;
}

.feature-title {
	color: white;
	font-size: 1.5rem;
	font-weight: 600;
	margin-bottom: 1.5rem;

	@media (max-width: 768px) {
		font-size: 1.25rem;
	}
}

.feature-indicators {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.indicator {
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.2);
	border-radius: 12px;
	padding: 0.75rem 1rem;
	color: rgba(255, 255, 255, 0.7);
	font-size: 0.9rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
	text-align: left;

	&:hover {
		background: rgba(255, 255, 255, 0.15);
		color: white;
		transform: translateX(5px);
	}

	&.active {
		background: linear-gradient(135deg, #ff5c00, #e55100);
		color: white;
		border-color: #ff5c00;
		transform: translateX(10px);
		box-shadow: 0 5px 15px rgba(255, 92, 0, 0.3);
	}

	@media (max-width: 768px) {
		padding: 0.625rem 0.875rem;
		font-size: 0.85rem;
	}
}

.indicator-text {
	display: block;
}

// Responsive adjustments
@media (max-width: 768px) {
	.content-container {
		gap: 1.5rem;
	}

	.glass-card {
		margin: 0 auto;
		max-width: 100%;
	}

	.feature-showcase {
		max-width: 100%;
	}
}

// Accessibility improvements
@media (prefers-reduced-motion: reduce) {
	* {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		transition-duration: 0.01ms !important;
	}
}

// Focus styles for better accessibility
.modern-input:focus,
.login-button:focus,
.secondary-button:focus,
.forgot-password:focus,
.indicator:focus {
	outline: 2px solid #ff5c00;
	outline-offset: 2px;
}

.form-section,
.features-section {
	display: flex;
	align-items: stretch;
}

.glass-card {
	height: 100%;
	display: flex;
	flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/pages/page-login.vue